// extracted by mini-css-extract-plugin
module.exports = {"PriceBox":"Prices_PriceBox__3XNSS","Price":"Prices_Price__2flJZ","OldPrice":"Prices_OldPrice__2iP_j","NewPrice":"Prices_NewPrice__1pIxC"};